import React from "react";
import { Button, Drawer, Space, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import { useAppTranslation } from "@/utils";
import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";
import MobileLoginEnableDisable from "@/mobile/Profile/2Fa/Login/MobileLoginEnableDisable";
import MobileCashEnableDisable from "./Cash/MobileCashEnableDisable";

const MobileProfile2Fa: React.FC = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const { profile } = DashboardRoutes;

  return (
    <Drawer
      open
      title={t("profile.twoStepPassword")}
      height={"100%"}
      placement={"bottom"}
      closeIcon={false}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(profile.mRoot.url);
          }}
        />
      }
    >
      <Space className={"tw:w-full"} orientation={"vertical"} size={"large"}>
        <Space className={"tw:w-full"} orientation={"vertical"}>
          <Typography.Title level={5}>بهبود امنیت</Typography.Title>
          <Typography.Text>برای امنیت بیشتر میتوانید از گزینه های زیر استفاده کنید</Typography.Text>
        </Space>
        {/* <LoginEnableDisable> */}
        <MobileLoginEnableDisable />
        {/* < /LoginEnableDisable> */}

        {/* <CashEnableDisable> */}
        <MobileCashEnableDisable />
        {/* </CashEnableDisable> */}
      </Space>
    </Drawer>
  );
};

export default MobileProfile2Fa;
